import Link from 'next/link'
import { memo, type ReactElement } from 'react'
import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { proxyGlobalAuth } from '../../../../../../../shared/proxies/proxyGlobalAuth'
import PlusIcon from '../../../../../../../shared/components/ui/icons/PlusIcon'
import { APP_RECURRING_PAYMENTS_NEW_PATH } from '../../../../../../../pages/app/recurring-charges/new'

function AddRecurringChargeButton (): ReactElement {
  const { siteTheme: { buttonColors } } = useSnapshot(proxyGlobalAuth)
  return (
    <Link href={APP_RECURRING_PAYMENTS_NEW_PATH}>
      <div
        className={cn(
          buttonColors.classes,
          'rounded py-2 px-4 text-white flex cursor-pointer'
        )}
      >
        <div className="flex justify-center items-center">
          <PlusIcon additionalClasses="w-5 h-5 mr-2" />
          <div className="text-lg font-semibold">New Recurring Charge</div>
        </div>
      </div>
    </Link>
  )
}

export default memo(AddRecurringChargeButton)
